import React from "react";
import "./12DBmanage.css";

const VIP12DBmanage = ({ projectId = "12" }) => {
  return (
    <div className="vip12-dbmanage-container">
      <div className="vip12-dbmanage-header">
        <h1 className="vip12-dbmanage-title">REBOA RCT - Database Management</h1>
        <p className="vip12-dbmanage-subtitle">
          Data Management & Administration
        </p>
      </div>

      <div className="vip12-dbmanage-content">
        <div className="preparation-notice">
          <div className="notice-icon">🗄️</div>
          <h2 className="notice-title">Database Management</h2>
          <p className="notice-message">
            The database management system is currently under development.
            <br />
            Please check back later.
          </p>
        </div>
      </div>
    </div>
  );
};

export default VIP12DBmanage;
